var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.78 63.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m105.03,10.9l-18.81,21.21c19.54-6.06,38.9-12.07,58.57-18.17-13.3-1.02-26.53-2.03-39.76-3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.73,8.97c-12.49-.95-24.99-1.91-37.54-2.87,5.83,8.77,11.47,17.27,17.17,25.84l20.37-22.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.9,34.71c-19.09,5.91-38,11.76-56.9,17.62.02.1.05.19.07.29,12.78.97,25.57,1.94,38.37,2.91l18.46-20.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.75,57.45c12.81.97,25.63,1.94,38.51,2.92-5.96-8.98-11.74-17.67-17.6-26.5l-20.91,23.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.53,61.21l-.07.18c-.67,1.69.42,2.77,2.03,2.01l.28-.13c.44-.21.87-.53,1.22-.94L100.11,3.55c.41-.47.71-1.01.85-1.54l.03-.13c.35-1.37-.51-2.2-1.82-1.77l-.23.08c-.55.18-1.1.56-1.55,1.07l-52.13,58.79c-.31.35-.56.76-.73,1.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPower);
export default __webpack_public_path__ + "static/media/No_Power.a9964bdd1e5453edae2982f342bc801b.svg";
export { ForwardRef as ReactComponent };